<template>
  <el-dialog class="wx-dialog" :title="title" :visible.sync="options.show" close="cancel" :width="options.width">
    <div class="gallery-chart">
      <p class="warn-chart">
        图文生成图片会涉及到字体版权问题，如图片用于商业用途，请将中文字体改为免费商用字体，
        或向字体公司购买商业授权!
        <el-button type="info" class="back-info" @click="cancel">返回修改</el-button>
      </p>
      <p class="gray-font">
        可免费用的商用字体： 楷体  宋体 黑体 Arial
      </p>
    </div>
    <div slot="footer" class="footer-dialog-article" style="text-align:center;margin-top:10px">
      <el-button type="success" @click="submit('uiEduction')">导出480px长图</el-button>
      <el-button type="success" @click="submit('uiEduction')">导出640px长图</el-button>
      <el-button type="success" @click="submit('uiEduction')">导出1080px长图</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MaterialService from '@/service/api/materialService'
import _ from 'lodash'

export default {
  props: {
    metaData: {
      type: Object,
      default: {}
    },
    cancelFn: {
      type: Function,
      default: () => undefined
    },
    submitFn: {
      type: Function,
      default: () => undefined
    },
    options: {
      type: Object,
      default: {}
    },
    title: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      list: []
    }
  },

  created () {
    this.getMyPic()
  },

  methods: {
    getMyPic () {
      const materialSystem = new MaterialService()
      const obj = {
        m: 'myimage',
        page: 1,
        tag: null
      }
      materialSystem.materialList(obj)
        .then(({ data }) => {
          this.list = data.data
        }, (error) => {
          this.$notify.error(error.message)
        })
    },
    clickPic (val) {
      if (this.submitFn && typeof this.submitFn === 'function') {
        this.submitFn(val)
      }
    },
    submit () {
      this.$destroy()
    },

    cancel () {
      if (this.cancelFn && typeof this.cancelFn === 'function') {
        this.cancelFn()
      }
      this.$destroy()
    }
  },

  destroyed () {
    document
      .getElementById('app')
      .removeChild(this.$el)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .gallery-chart{
    margin-top: 20px;
    .warn-chart{
      color: #444;
      line-height: 2;
    }
    .back-info{
      padding: 4px 8px;
      background: #f1f1f1;
      color: #9a9a9a;
      border-color: #f1f1f1;
      margin-left: 20px;
    }
    .gray-font{
      color: #adadad;
      margin: 15px 0
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/growthChart.vue